import moment from 'moment';
import i18n from '@i18n';

const fppFormat = 'YYYY-MM-DD';
const shortDateFormat = 'DD.MM';
const dayOfWeekFormat = 'dddd';

const dnes = moment().format(fppFormat);
const zajtra = moment()
    .add(1, 'days')
    .format(fppFormat);

export const INTERVALS = {
    ALL: {
        text: i18n('enum.calendar.anytime'),
        trackValue: 'Kedykolvek'
    },
    TODAY: {
        date: [dnes],
        text: i18n('enum.calendar.dnes'),
        trackValue: 'Dnes'
    },
    TODAY_AND_TOMORROW: {
        date: [dnes, zajtra],
        text: i18n('enum.calendar.dnes-zajtra'),
        trackValue: 'Dnes a Zajtra'
    },
    TOMORROW: {
        date: [zajtra],
        text: i18n('commons.datum.zajtra'),
        trackValue: 'Zajtra'
    },
    HOUR: {
        minutes: 60,
        text: i18n('calendar.in') + ' ' + i18n('enum.calendar.in.1-hod'),
        trackValue: 'Dnes do 1 hod'
    },
    HOURS3: {
        minutes: 180,
        text: i18n('calendar.in') + ' ' + i18n('enum.calendar.in.3-hod'),
        trackValue: 'Dnes do 3 hod'
    }
};

export const DEFAULT_INTERVAL = 'ALL';

export function formatBettingDayLabel(dayMoment) {
    return dayMoment.format(dayOfWeekFormat) + ' ' + dayMoment.format(shortDateFormat);
}
